import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { htmlDecode } from 'htmlencode';
import URL from 'url-parse';
import isUrl from 'validator/lib/isURL';
import ReactDOMServer from 'react-dom/server';

/* eslint-disable import/prefer-default-export */

var BUTTON_MODE = {
  NO_BUTTON: 'no_button',
  BUTTON_PER_COLUMN: 'button_per_column',
  BUTTON_PER_LAYOUT: 'button_per_layout'
};

var MIN_RATIO = 0.2;
var MAX_RATIO = 2.0;
var DEFAULT_RATIO = 0.75;
var IMAGE_TYPE_REGULAR = 'regular';
var IMAGE_TYPE_ROUNDED = 'rounded';
var MIN_ROUNDED_HEIGHT = 80;

var contentColumnPropType = PropTypes.shape({
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  enabled: PropTypes.bool
});

var contentColumnDefaultProps = PropTypes.shape({
  options: {}
});

var contentPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  type: PropTypes.string,
  index: PropTypes.number
});

var contentDefaultProps = {
  id: false,
  value: '',
  type: ''
};

var contentComponentPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  type: PropTypes.string.isRequired,
  content: PropTypes.string,
  imageType: PropTypes.oneOf([IMAGE_TYPE_REGULAR, IMAGE_TYPE_ROUNDED])
});

var contentLayoutProps = PropTypes.shape({
  classes: PropTypes.string,
  img: PropTypes.string,
  imageResizableEnabled: PropTypes.bool,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number
});

var CONTENT_SECTION_TYPE = {
  base: 'base',
  gallery: 'gallery',
  slider: 'slider',
  blockBuilder: 'builder'
};

/* eslint-disable import/prefer-default-export */

var DEFAULT_COLUMN_COUNT = 4;

var propTypes = {
  content: contentPropType.isRequired,
  title: PropTypes.func.isRequired,
  subTitle: PropTypes.func.isRequired,
  column: PropTypes.func.isRequired,
  text: PropTypes.func.isRequired,
  button: PropTypes.func.isRequired
};

var defaultProps = {};

var ContentSectionBase = function ContentSectionBase(props) {
  var _props$content = props.content,
      id = _props$content.id,
      columns = _props$content.columns,
      type = _props$content.type,
      columnCount = _props$content.options.columnCount,
      title = props.title,
      subTitle = props.subTitle,
      text = props.text,
      button = props.button,
      column = props.column;


  var columnsCountClass = type === CONTENT_SECTION_TYPE.gallery ? 'c-' + type + '__' + (columnCount || DEFAULT_COLUMN_COUNT) + 'columns' : '';
  var lightboxGroupClass = type === CONTENT_SECTION_TYPE.gallery ? 'js-lightbox-group' : '';
  var mainClasses = classNames('c-section__main ' + lightboxGroupClass, columnsCountClass, 'l-columns');

  return React.createElement(
    'div',
    { className: 'c-section__wrapper', key: id },
    React.createElement(
      'header',
      { className: 'c-section__header' },
      title(),
      subTitle()
    ),
    React.createElement(
      'main',
      { className: mainClasses },
      columns.map(column)
    ),
    React.createElement(
      'footer',
      { className: 'c-section__footer' },
      text(),
      button()
    )
  );
};

ContentSectionBase.propTypes = propTypes;
ContentSectionBase.defaultProps = defaultProps;

var moduleOptionsProps = PropTypes.shape({
  backgroundColor: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  backgroundImage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  backgroundImageId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
});

var moduleDefaultOptionsProps = {
  backgroundColor: false,
  backgroundImage: false,
  backgroundImageId: false
};

var CONTENT_COMPONENT_TYPE = {
  button: 'button',
  breadcrumbs: 'breadcrumbs',
  news: 'news',
  buttonSecondary: 'buttonSecondary',
  googleMaps: 'googleMaps',
  hr: 'hr',
  html: 'html',
  image: 'image',
  galleryImage: 'galleryImage',
  subtitle: 'subtitle',
  text: 'text',
  title: 'title',
  sliderImage: 'sliderImage',
  video: 'video',
  dynamic: 'dynamic',
  divider: 'divider'
};

var propTypes$1 = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  type: PropTypes.string
};

var defaultProps$1 = {
  classes: '',
  containerClassName: '',
  type: CONTENT_COMPONENT_TYPE.hr
};

var ContentComponentHr = function ContentComponentHr(props) {
  var type = props.type,
      classes = props.classes,
      containerClassName = props.containerClassName;


  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement('hr', { className: componentClasses });
};

ContentComponentHr.propTypes = propTypes$1;
ContentComponentHr.defaultProps = defaultProps$1;

/* eslint-disable react/no-danger */
var propTypes$2 = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  content: PropTypes.string,
  fromSectionOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  type: PropTypes.string
};

var defaultProps$2 = {
  classes: '',
  containerClassName: '',
  content: '',
  fromSectionOption: false,
  type: CONTENT_COMPONENT_TYPE.button
};

var ContentComponentButton = function ContentComponentButton(props) {
  var classes = props.classes,
      containerClassName = props.containerClassName,
      contentEncoded = props.content,
      fromSectionOption = props.fromSectionOption,
      type = props.type;

  var content = htmlDecode(contentEncoded);
  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement('div', {
    dangerouslySetInnerHTML: { __html: content },
    className: componentClasses
  });
};

ContentComponentButton.propTypes = propTypes$2;
ContentComponentButton.defaultProps = defaultProps$2;

var LINK_TYPE_NONE = 'LINK_NONE';
var LINK_TYPE_INTERNAL = 'LINK_INTERNAL';
var LINK_TYPE_EXTERNAL = 'LINK_EXTERNAL';
var LINK_TYPE_EMAIL = 'LINK_EMAIL';

var completeUrl = function completeUrl(hyperlink) {
  if (!hyperlink || hyperlink === '' || hyperlink.indexOf('/') === 0) {
    return hyperlink;
  }
  if (hyperlink.indexOf('http') === 0) {
    return URL(hyperlink).toString();
  }
  var url = URL('http://' + hyperlink);
  return url.toString();
};

var getLinkType = function getLinkType(hyperlink) {
  var defaultLinkType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LINK_TYPE_NONE;

  if (hyperlink === '' || !hyperlink) {
    return defaultLinkType;
  } else if (hyperlink === false) {
    return LINK_TYPE_INTERNAL;
  } else if (hyperlink.indexOf('/') === 0) {
    return LINK_TYPE_INTERNAL;
  } else if (hyperlink.indexOf('@') !== -1) {
    return LINK_TYPE_EMAIL;
  }
  return LINK_TYPE_EXTERNAL;
};

var propTypes$3 = {
  hyperlink: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

var defaultProps$3 = {
  className: '',
  hyperlink: ''
};

var LinkedImage = function LinkedImage(props) {
  var linkType = getLinkType(props.hyperlink);
  if (props.hyperlink && props.hyperlink !== '') {
    var attrs = {
      href: props.hyperlink,
      className: classNames(props.className, 'c-image__link')
    };
    if (linkType === LINK_TYPE_EXTERNAL) {
      attrs.target = '_blank';
    }
    return React.createElement(
      'a',
      attrs,
      props.children
    );
  }

  return React.createElement(
    'div',
    { className: classNames(props.className, 'c-image__link') },
    props.children
  );
};

LinkedImage.propTypes = propTypes$3;
LinkedImage.defaultProps = defaultProps$3;

var IMAGE_PLACEHOLDER_URL = '/images/block/placeholder.png';
var LIGHTBOX_CLASSNAME = 'js-image--lightbox';

var ROUTE_MEDIA_GET = '/media/get/web';

var getYoutubeEmbedUrl = function getYoutubeEmbedUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!isUrl(url)) {
    return '';
  }
  var urlSplit = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  var embedUrl = undefined !== urlSplit[2] ? urlSplit[2].split(/[^0-9a-z_-]/i)[0] : urlSplit[0];
  return embedUrl ? 'https://www.youtube.com/embed/' + embedUrl : '';
};

var isVideoUrl = function isVideoUrl(url) {
  if (typeof url !== 'string' || !isUrl(url)) {
    return false;
  }
  return URL(url).hostname.indexOf('youtu') !== -1;
};

var getLargeImageUrl = function getLargeImageUrl(hyperlink) {
  if (!hyperlink) {
    return false;
  }

  var url = URL(hyperlink);
  if (!url.pathname.indexOf('/media/get/') === 0) {
    return hyperlink;
  }
  var path = url.pathname.split('/');
  path[3] = 'large';
  var largeImageUrl = path.join('/');
  return URL(largeImageUrl).toString();
};

var getWebMediaUrl = function getWebMediaUrl(media) {
  var id = media.id,
      filename = media.filename,
      fileExtension = media.fileExtension;


  if (!id || !filename || !fileExtension) {
    return null;
  }

  var path = id + '/' + encodeURIComponent(filename) + fileExtension;

  return ROUTE_MEDIA_GET + '/' + path;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var createRoundedImagesStyles = function createRoundedImagesStyles(width, height) {
  var styles = {};

  if (height) {
    styles.width = height + 'px';
    styles.paddingBottom = height + 'px';
  }

  return styles;
};

var createRegularImagesStyles = function createRegularImagesStyles(width, height) {
  var styles = {};

  if (width && height) {
    var ratio = height / width;
    var paddingBottom = ratio * 100;
    styles.paddingBottom = paddingBottom + '%';
  }

  return styles;
};

var ContentComponentImageContainer = function (_React$Component) {
  inherits(ContentComponentImageContainer, _React$Component);

  function ContentComponentImageContainer() {
    classCallCheck(this, ContentComponentImageContainer);
    return possibleConstructorReturn(this, (ContentComponentImageContainer.__proto__ || Object.getPrototypeOf(ContentComponentImageContainer)).apply(this, arguments));
  }

  createClass(ContentComponentImageContainer, [{
    key: 'resolveContainerStyles',
    value: function resolveContainerStyles() {
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          imageType = _props.imageType;


      switch (imageType) {
        case IMAGE_TYPE_ROUNDED:
          return createRoundedImagesStyles(width, height);

        default:
          return createRegularImagesStyles(width, height);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.type === CONTENT_COMPONENT_TYPE.image) {
        return React.createElement(
          'div',
          { className: 'c-image__container', style: this.resolveContainerStyles() },
          this.props.children
        );
      }

      return this.props.children;
    }
  }]);
  return ContentComponentImageContainer;
}(React.Component);

ContentComponentImageContainer.propTypes = {
  type: PropTypes.string,
  imageType: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  children: PropTypes.element.isRequired
};

ContentComponentImageContainer.defaultProps = {
  type: CONTENT_COMPONENT_TYPE.image,
  imageType: 'regular',
  width: null,
  height: null
};

var propTypes$4 = {
  alt: PropTypes.string,
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  tooltip: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  hyperlink: PropTypes.string,
  imageType: PropTypes.string,
  hasCustomSize: PropTypes.bool,
  lightbox: PropTypes.bool // add lightbox url if hyperlink is empty
};

var defaultProps$4 = {
  alt: '',
  classes: '',
  containerClassName: '',
  tooltip: '',
  type: CONTENT_COMPONENT_TYPE.image,
  url: '',
  hyperlink: '',
  lightbox: true,
  imageWidth: null,
  imageHeight: null,
  imageType: null,
  hasCustomSize: false
};

var ContentComponentImage = function ContentComponentImage(props) {
  var _classNames;

  var alt = props.alt,
      classes = props.classes,
      containerClassName = props.containerClassName,
      tooltip = props.tooltip,
      type = props.type,
      imageType = props.imageType,
      url = props.url,
      hyperlink = props.hyperlink,
      lightbox = props.lightbox,
      imageWidth = props.imageWidth,
      imageHeight = props.imageHeight,
      hasCustomSize = props.hasCustomSize;


  var componentClasses = classNames(classes, containerClassName, 'c-image', 'c-image-' + type);
  var lightboxHyperlink = !hyperlink && lightbox ? getLargeImageUrl(url) : '';
  var usePlaceholderUrl = !lightboxHyperlink && lightbox ? IMAGE_PLACEHOLDER_URL : null;

  return React.createElement(
    'div',
    { className: componentClasses },
    React.createElement(
      ContentComponentImageContainer,
      {
        type: type,
        imageType: imageType,
        width: imageWidth,
        height: imageHeight
      },
      React.createElement(
        LinkedImage,
        {
          hyperlink: hyperlink || lightboxHyperlink || usePlaceholderUrl,
          className: classNames((_classNames = {}, defineProperty(_classNames, LIGHTBOX_CLASSNAME, lightboxHyperlink || usePlaceholderUrl), defineProperty(_classNames, 'c-image__link--has-custom-size', hasCustomSize), _classNames))
        },
        React.createElement('img', {
          className: classNames('c-' + type + '__element', defineProperty({}, 'c-' + type + '__element--has-custom-size', hasCustomSize)),
          src: url || IMAGE_PLACEHOLDER_URL,
          alt: alt,
          title: tooltip
        })
      )
    )
  );
};

ContentComponentImage.propTypes = propTypes$4;
ContentComponentImage.defaultProps = defaultProps$4;

var _class;
var _temp;

var containerStyles = {
  float: 'left',
  overflow: 'hidden',
  position: 'relative',
  display: 'block',
  height: 'auto'
};

var ContentComponentGalleryImage = (_temp = _class = function (_Component) {
  inherits(ContentComponentGalleryImage, _Component);

  function ContentComponentGalleryImage() {
    classCallCheck(this, ContentComponentGalleryImage);
    return possibleConstructorReturn(this, (ContentComponentGalleryImage.__proto__ || Object.getPrototypeOf(ContentComponentGalleryImage)).apply(this, arguments));
  }

  createClass(ContentComponentGalleryImage, [{
    key: 'renderImage',
    value: function renderImage() {
      var _props = this.props,
          id = _props.id,
          alt = _props.alt,
          containerClassName = _props.containerClassName,
          tooltip = _props.tooltip,
          type = _props.type,
          url = _props.url,
          hyperlink = _props.hyperlink;

      var key = id + '-image';
      var component = { url: url, type: type, tooltip: tooltip, alt: alt, hyperlink: hyperlink };

      return React.createElement(ContentComponentImage, _extends({
        key: key,
        containerClassName: containerClassName
      }, component));
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = this.props.classes;

      var type = CONTENT_COMPONENT_TYPE.galleryImage;
      var componentClasses = classNames(classes, 'c-' + type);

      return React.createElement(
        'div',
        {
          className: componentClasses,
          style: _extends({}, containerStyles)
        },
        this.renderImage()
      );
    }
  }]);
  return ContentComponentGalleryImage;
}(Component), _class.propTypes = {
  id: PropTypes.string,
  alt: PropTypes.string,
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  tooltip: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  hyperlink: PropTypes.string
}, _class.defaultProps = {
  id: '',
  alt: '',
  classes: '',
  containerClassName: '',
  tooltip: '',
  type: CONTENT_COMPONENT_TYPE.galleryImage,
  url: '',
  hyperlink: ''
}, _temp);

/* eslint-disable react/no-danger */
var propTypes$5 = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  content: PropTypes.string,
  fromSectionOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  type: PropTypes.string
};

var defaultProps$5 = {
  className: '',
  containerClassName: '',
  content: '',
  fromSectionOption: false,
  type: CONTENT_COMPONENT_TYPE.text
};

var ContentComponentText = function ContentComponentText(props) {
  var className = props.className,
      containerClassName = props.containerClassName,
      contentEncoded = props.content,
      fromSectionOption = props.fromSectionOption,
      type = props.type;

  var content = htmlDecode(contentEncoded);

  var componentClasses = classNames(className, containerClassName, 'c-' + type);

  // render edit behavior
  return React.createElement('div', {
    className: componentClasses,
    dangerouslySetInnerHTML: { __html: content }
  });
};

ContentComponentText.propTypes = propTypes$5;
ContentComponentText.defaultProps = defaultProps$5;

/* eslint-disable react/no-danger */
var propTypes$6 = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  content: PropTypes.string,
  fromSectionOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  type: PropTypes.string
};

var defaultProps$6 = {
  classes: '',
  containerClassName: '',
  content: '',
  fromSectionOption: false,
  type: CONTENT_COMPONENT_TYPE.title
};

var ContentComponentTitle = function ContentComponentTitle(props) {
  var classes = props.classes,
      containerClassName = props.containerClassName,
      contentEncoded = props.content,
      fromSectionOption = props.fromSectionOption,
      type = props.type;

  var content = htmlDecode(contentEncoded);
  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement('div', {
    dangerouslySetInnerHTML: { __html: content },
    className: componentClasses
  });
};

ContentComponentTitle.propTypes = propTypes$6;
ContentComponentTitle.defaultProps = defaultProps$6;

/* eslint-disable react/no-danger */
var propTypes$7 = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  content: PropTypes.string,
  fromSectionOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  type: PropTypes.string
};

var defaultProps$7 = {
  classes: '',
  containerClassName: '',
  content: '',
  fromSectionOption: false,
  type: CONTENT_COMPONENT_TYPE.subtitle
};

var ContentComponentTitle$1 = function ContentComponentTitle(props) {
  var classes = props.classes,
      containerClassName = props.containerClassName,
      contentEncoded = props.content,
      fromSectionOption = props.fromSectionOption,
      type = props.type;

  var content = htmlDecode(contentEncoded);
  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement('div', {
    dangerouslySetInnerHTML: { __html: content },
    className: componentClasses
  });
};

ContentComponentTitle$1.propTypes = propTypes$7;
ContentComponentTitle$1.defaultProps = defaultProps$7;

/* eslint-disable react/no-danger */
var propTypes$8 = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  content: PropTypes.string,
  type: PropTypes.string
};

var defaultProps$8 = {
  classes: '',
  containerClassName: '',
  content: '',
  type: CONTENT_COMPONENT_TYPE.html
};

var ContentComponentHtml = function ContentComponentHtml(props) {
  var classes = props.classes,
      containerClassName = props.containerClassName,
      contentEncoded = props.content,
      type = props.type;

  var content = htmlDecode(contentEncoded);

  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement('div', {
    className: componentClasses,
    dangerouslySetInnerHTML: { __html: content }
  });
};

ContentComponentHtml.propTypes = propTypes$8;
ContentComponentHtml.defaultProps = defaultProps$8;

/* eslint-disable react/no-danger */
var MAP_STYLES = {
  default: { value: '', title: 'standaard' },
  grayscale: { value: 'grayscale', title: 'zwart wit' }
};

var propTypes$9 = {
  address: PropTypes.string,
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  mapStyle: PropTypes.string,
  mapZoom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  markerTitle: PropTypes.string,
  markerValue: PropTypes.string,
  type: PropTypes.string,
  hasStaticMap: PropTypes.bool
};

var defaultProps$9 = {
  address: '',
  classes: '',
  containerClassName: '',
  latitude: '50.8251460',
  longitude: '4.3110560',
  mapStyle: MAP_STYLES.DEFAULT,
  mapZoom: 15,
  markerTitle: '',
  markerValue: '',
  type: CONTENT_COMPONENT_TYPE.googleMaps,
  hasStaticMap: false
};

var stripTags = function stripTags(str) {
  return str.replace(/<\/?[^>]+(>|$)/g, '');
};

var ContentGoogleMaps = function ContentGoogleMaps(props) {
  var address = props.address,
      classes = props.classes,
      containerClassName = props.containerClassName,
      latitude = props.latitude,
      longitude = props.longitude,
      mapStyle = props.mapStyle,
      mapZoom = props.mapZoom,
      markerTitleEncoded = props.markerTitle,
      markerValue = props.markerValue,
      type = props.type,
      hasStaticMap = props.hasStaticMap;


  var componentClasses = classNames(classes, containerClassName, 'c-' + type);
  var markerTitle = htmlDecode(markerTitleEncoded);

  if (hasStaticMap) {
    var sizes = {
      phone: 600,
      'tablet-portrait': 960,
      'tablet-landscape': 1200,
      desktop: 1800,
      wide: 2048
    };

    var srcSet = Object.keys(sizes).map(function (key) {
      var url = props['static_image_' + key] + ' 1x, ' + props['static_image_' + key + '2x'] + ' 2x';

      if (!url) {
        return null;
      }

      return {
        url: url,
        media: '(max-width: ' + sizes[key] + 'px)'
      };
    }).filter(function (item) {
      return item !== null;
    });

    var firstItem = srcSet[0];
    var plainUrl = '' + props['static_image_desktop'];

    return React.createElement(
      'div',
      { className: 'c-googleMaps c-googleMaps--static' },
      React.createElement(
        'a',
        { target: '_blank', href: 'https://www.google.com/maps/place/' + address },
        React.createElement(
          'picture',
          null,
          srcSet.map(function (_ref) {
            var url = _ref.url,
                media = _ref.media;
            return React.createElement('source', { key: url, media: media, srcSet: url });
          }),
          firstItem && React.createElement('img', { src: plainUrl, srcSet: firstItem.url, alt: stripTags(markerTitle), className: 'c-googleMaps--style_' + (mapStyle ? 'grayscale' : 'normal') })
        )
      )
    );
  }

  return React.createElement('div', {
    className: componentClasses,
    'data-lat': latitude,
    'data-lon': longitude,
    'data-address': address,
    'data-markervalue': markerValue,
    'data-markertitle': markerTitle,
    'data-map-style': mapStyle,
    'data-zoom': mapZoom
  });
};

ContentGoogleMaps.propTypes = propTypes$9;
ContentGoogleMaps.defaultProps = defaultProps$9;

/* eslint-disable react/no-unused-prop-types */
var optionalComponentProp = PropTypes.oneOfType([PropTypes.bool, PropTypes.string]);

var ContentComponentSliderImage = function (_Component) {
  inherits(ContentComponentSliderImage, _Component);

  function ContentComponentSliderImage() {
    classCallCheck(this, ContentComponentSliderImage);
    return possibleConstructorReturn(this, (ContentComponentSliderImage.__proto__ || Object.getPrototypeOf(ContentComponentSliderImage)).apply(this, arguments));
  }

  createClass(ContentComponentSliderImage, [{
    key: 'renderImage',
    value: function renderImage() {
      var _props = this.props,
          alt = _props.alt,
          url = _props.url,
          tooltip = _props.tooltip,
          containerClassName = _props.containerClassName;

      var component = { url: url, tooltip: tooltip, alt: alt, lightbox: false };
      return React.createElement(ContentComponentImage, _extends({}, component, {
        containerClassName: containerClassName
      }));
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var title = this.props.title;

      if (title) {
        var component = { type: 'title', tag: 'h2', content: title };
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({}, component, { onChange: this.onComponentContentChange }));
      }
      return null;
    }
  }, {
    key: 'renderSubTitle',
    value: function renderSubTitle() {
      var subtitle = this.props.subtitle;

      if (subtitle) {
        var component = { type: 'title', tag: 'h3', content: subtitle };
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({}, component, { onChange: this.onComponentContentChange }));
      }
      return null;
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var _props2 = this.props,
          content = _props2.buttonContent,
          hyperlink = _props2.buttonHyperlink;

      if (content) {
        var component = { type: 'button', content: content, hyperlink: hyperlink };
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({}, component, { onChange: this.onComponentContentChange }));
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = this.props.classes;

      var type = CONTENT_COMPONENT_TYPE.galleryImage;
      var componentClasses = classNames(classes, 'c-' + type);
      return React.createElement(
        'div',
        { className: componentClasses },
        this.renderImage()
      );
    }
  }]);
  return ContentComponentSliderImage;
}(Component);

ContentComponentSliderImage.propTypes = {
  alt: PropTypes.string, // Section Component data
  buttonContent: optionalComponentProp, // Section Component data
  buttonHyperlink: optionalComponentProp, // Section Component data
  classes: PropTypes.string, // Section Component data,
  containerClassName: PropTypes.string,
  subtitle: optionalComponentProp, // Section Component data
  title: optionalComponentProp, // Section Component data
  tooltip: PropTypes.string, // Section Component data
  type: PropTypes.string, // Section Component data
  url: PropTypes.string, // Section Component data
  visible: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]) // Section Component data
};

// Optional component properties (title, subtitle, buttonContent, buttonHyperlink, ... ) will
// be false if they are not present in the module (aka blocks) definition
ContentComponentSliderImage.defaultProps = {
  alt: '',
  buttonContent: false,
  buttonHyperlink: false,
  classes: '',
  containerClassName: '',
  subtitle: false,
  title: false,
  tooltip: '',
  type: CONTENT_COMPONENT_TYPE.galleryImage,
  url: '',
  visible: true
};

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
var propTypes$10 = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  imageType: PropTypes.string,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number
};

var defaultProps$10 = {
  classes: '',
  containerClassName: '',
  type: CONTENT_COMPONENT_TYPE.image,
  imageType: '',
  url: '',
  imageWidth: null,
  imageHeight: null
};

function ContentComponentVideo(props) {
  var classes = props.classes,
      containerClassName = props.containerClassName,
      type = props.type,
      imageType = props.imageType,
      url = props.url,
      imageWidth = props.imageWidth,
      imageHeight = props.imageHeight;

  var embedUrl = getYoutubeEmbedUrl(url);

  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement(
    'div',
    { className: componentClasses },
    React.createElement(
      ContentComponentImageContainer,
      {
        type: type,
        imageType: imageType,
        width: imageWidth,
        height: imageHeight
      },
      React.createElement(
        'div',
        { className: 'c-image__iframe-wrapper' },
        React.createElement('iframe', {
          className: 'c-image__iframe',
          title: 'title',
          width: '100%',
          height: '100%',
          frameBorder: '0',
          allowFullScreen: '1',
          src: embedUrl
        })
      )
    )
  );
}

ContentComponentVideo.propTypes = propTypes$10;
ContentComponentVideo.defaultProps = defaultProps$10;

/* eslint-disable react/no-danger */
function ContentComponentDynamic(props) {
  var type = props.type,
      classes = props.classes,
      containerClassName = props.containerClassName;


  var componentClasses = classNames(classes, containerClassName, 'c-' + type);

  return React.createElement(
    'div',
    { className: componentClasses },
    '###BB_REPLACE_DYNAMIC_',
    props.url,
    '###'
  );
}

ContentComponentDynamic.propTypes = {
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string.isRequired
};

ContentComponentDynamic.defaultProps = {
  classes: '',
  containerClassName: '',
  type: CONTENT_COMPONENT_TYPE.dynamic
};

var ContentComponents = {
  button: ContentComponentButton,
  buttonSecondary: ContentComponentButton,
  googleMaps: ContentGoogleMaps,
  hr: ContentComponentHr,
  html: ContentComponentHtml,
  image: ContentComponentImage,
  galleryImage: ContentComponentGalleryImage,
  subtitle: ContentComponentTitle$1,
  text: ContentComponentText,
  title: ContentComponentTitle,
  sliderImage: ContentComponentSliderImage,
  video: ContentComponentVideo,
  dynamic: ContentComponentDynamic
};

/* eslint-disable import/prefer-default-export */

var containerClass = function containerClass(contentType, componentType) {
  if (contentType) {
    return 'c-' + contentType + '__' + componentType;
  }
  return '';
};

var _class$1;
var _temp$1;

var BrowsboxContentColumn = (_temp$1 = _class$1 = function (_Component) {
  inherits(BrowsboxContentColumn, _Component);

  function BrowsboxContentColumn(props) {
    classCallCheck(this, BrowsboxContentColumn);

    var _this = possibleConstructorReturn(this, (BrowsboxContentColumn.__proto__ || Object.getPrototypeOf(BrowsboxContentColumn)).call(this, props));

    _this.renderComponent = _this.renderComponent.bind(_this);
    return _this;
  }

  createClass(BrowsboxContentColumn, [{
    key: 'shouldRenderComponent',
    value: function shouldRenderComponent(component) {
      var _props$content = this.props.content,
          options = _props$content.options,
          contentType = _props$content.type;

      var type = component.type;

      if (contentType === CONTENT_SECTION_TYPE.blockBuilder) {
        // block builder should render all components without additional conditions
        return true;
      }

      if (type === CONTENT_COMPONENT_TYPE.button) {
        return options.primaryButtonsActive && options.buttonDisplay === BUTTON_MODE.BUTTON_PER_COLUMN;
      }

      if (type === CONTENT_COMPONENT_TYPE.buttonSecondary) {
        return options.secondaryButtonsActive && options.buttonDisplay === BUTTON_MODE.BUTTON_PER_COLUMN;
      }

      return true;
    }
  }, {
    key: 'renderComponent',
    value: function renderComponent(component, idx) {
      var _props = this.props,
          onChange = _props.onChange,
          type = _props.type,
          content = _props.content;


      if (!this.shouldRenderComponent(component)) {
        return null;
      }

      var componentTag = type || component.type;
      if (componentTag === 'image' && isVideoUrl(component.url)) {
        componentTag = 'video';
      }
      var Tag = ContentComponents[componentTag];
      var containerClassName = containerClass(content.type, component.type);
      if (Tag) {
        return React.createElement(Tag, _extends({
          key: idx,
          onChange: onChange,
          containerClassName: containerClassName
        }, component));
      }
      return React.createElement(
        'div',
        { key: idx },
        'Missing component ',
        React.createElement(
          'b',
          null,
          component.type
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          column = _props2.column,
          components = _props2.components,
          children = _props2.children,
          type = _props2.type;


      var classes = classNames('l-column', column.classes, defineProperty({}, 'o-content-column-' + type, type));

      if (column.enabled === false) {
        return null;
      }

      return React.createElement(
        'div',
        {
          className: classes,
          id: column.id
        },
        components.map(this.renderComponent),
        children
      );
    }
  }]);
  return BrowsboxContentColumn;
}(Component), _class$1.propTypes = {
  column: contentColumnPropType.isRequired,
  components: PropTypes.arrayOf(contentComponentPropType),
  onChange: PropTypes.func,
  children: PropTypes.node,
  type: PropTypes.string, // Override component.type to determine ContentComponents to add
  content: contentPropType.isRequired
}, _class$1.defaultProps = {
  components: [],
  children: null,
  type: '',
  contentType: '',
  onChange: function onChange() {}
}, _temp$1);

var BrowsboxContentItem = function (_Component) {
  inherits(BrowsboxContentItem, _Component);

  function BrowsboxContentItem(props) {
    classCallCheck(this, BrowsboxContentItem);

    var _this = possibleConstructorReturn(this, (BrowsboxContentItem.__proto__ || Object.getPrototypeOf(BrowsboxContentItem)).call(this, props));

    _this.renderColumn = _this.renderColumn.bind(_this);
    return _this;
  }

  createClass(BrowsboxContentItem, [{
    key: 'renderTitle',
    value: function renderTitle() {
      var _props$content = this.props.content,
          options = _props$content.options,
          id = _props$content.id,
          type = _props$content.type;
      var content = options.title;

      if (content) {
        var component = { type: CONTENT_COMPONENT_TYPE.title, content: content, id: id, fromSectionOption: 'title' };
        var containerClassName = containerClass(type, CONTENT_COMPONENT_TYPE.title);
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({
          onChange: this.onComponentContentChange,
          containerClassName: containerClassName
        }, component));
      }
      return null;
    }
  }, {
    key: 'renderSubTitle',
    value: function renderSubTitle() {
      var _props$content2 = this.props.content,
          options = _props$content2.options,
          id = _props$content2.id,
          type = _props$content2.type;
      var content = options.subtitle;

      if (content) {
        var component = { type: CONTENT_COMPONENT_TYPE.subtitle, content: content, id: id, fromSectionOption: 'subtitle' };
        var containerClassName = containerClass(type, CONTENT_COMPONENT_TYPE.subtitle);
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({
          onChange: this.onComponentContentChange,
          containerClassName: containerClassName
        }, component));
      }
      return null;
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var buttonDisplay = this.props.content.options.buttonDisplay;


      if (typeof buttonDisplay !== 'undefined' && buttonDisplay !== BUTTON_MODE.BUTTON_PER_LAYOUT) {
        return null;
      }

      return React.createElement(
        React.Fragment,
        null,
        this.renderPrimaryButton(),
        this.renderSecondaryButton()
      );
    }
  }, {
    key: 'renderPrimaryButton',
    value: function renderPrimaryButton() {
      var primaryButtonsActive = this.props.content.options.primaryButtonsActive;


      if (primaryButtonsActive) {
        return this.renderButtonFromSectionOption('buttonContent');
      }

      return null;
    }
  }, {
    key: 'renderSecondaryButton',
    value: function renderSecondaryButton() {
      var secondaryButtonsActive = this.props.content.options.secondaryButtonsActive;


      if (secondaryButtonsActive) {
        return this.renderButtonFromSectionOption('buttonSecondaryContent');
      }

      return null;
    }
  }, {
    key: 'renderButtonFromSectionOption',
    value: function renderButtonFromSectionOption(name) {
      var _props$content3 = this.props.content,
          options = _props$content3.options,
          id = _props$content3.id,
          type = _props$content3.type;

      var buttonContent = options[name];

      if (buttonContent) {
        var component = {
          type: CONTENT_COMPONENT_TYPE.button,
          content: buttonContent,
          id: id,
          fromSectionOption: name
        };

        var containerClassName = containerClass(type, CONTENT_COMPONENT_TYPE.button);
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({
          onChange: this.onComponentContentChange,
          containerClassName: containerClassName
        }, component));
      }

      return null;
    }
  }, {
    key: 'renderText',
    value: function renderText() {
      var _props$content4 = this.props.content,
          options = _props$content4.options,
          id = _props$content4.id,
          type = _props$content4.type;
      var content = options.text;

      if (content) {
        var component = { type: CONTENT_COMPONENT_TYPE.text, content: content, id: id, fromSectionOption: 'text' };
        var containerClassName = containerClass(type, CONTENT_COMPONENT_TYPE.text);
        var Tag = ContentComponents[component.type];
        return React.createElement(Tag, _extends({
          onChange: this.onComponentContentChange,
          containerClassName: containerClassName
        }, component));
      }
      return null;
    }
  }, {
    key: 'renderColumn',
    value: function renderColumn(column, idx) {
      var content = this.props.content;


      if (column.visible !== false) {
        return React.createElement(BrowsboxContentColumn, {
          key: idx,
          column: column,
          content: content,
          components: column.components,
          onChange: this.onComponentContentChange
        });
      }
      return null;
    }
  }, {
    key: 'renderSection',
    value: function renderSection() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          options = _props.content.options;


      var classes = classNames('c-section', 'c-section-' + content.type, content.classes, options.colorSchemeClass, options.layoutClasses, defineProperty({}, 'c-section--button-align-' + options.buttonAlign, Boolean(options.buttonAlign)));

      // section style from section options
      var sectionStyleOptions = {};
      if (content.options && content.options.backgroundColor) {
        sectionStyleOptions.backgroundColor = content.options.backgroundColor;
      }
      if (content.options && content.options.backgroundImage) {
        sectionStyleOptions.backgroundImage = 'url(' + content.options.backgroundImage + ')';
      }

      return React.createElement(
        'section',
        {
          style: sectionStyleOptions,
          className: classes,
          id: content.id
        },
        React.createElement(ContentSectionBase, {
          className: 'c-section__wrapper',
          content: content,
          title: function title() {
            return _this2.renderTitle();
          },
          subTitle: function subTitle() {
            return _this2.renderSubTitle();
          },
          text: function text() {
            return _this2.renderText();
          },
          button: function button() {
            return _this2.renderButtons();
          },
          column: this.renderColumn
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderSection();
    }
  }]);
  return BrowsboxContentItem;
}(Component);

BrowsboxContentItem.propTypes = {
  content: contentPropType.isRequired,
  id: PropTypes.number.isRequired // eslint-disable-line react/no-unused-prop-types
};

BrowsboxContentItem.defaultProps = {
  moduleOptions: moduleDefaultOptionsProps
};

function renderItem(content) {
  return React.createElement(BrowsboxContentItem, {
    id: content.id,
    key: content.id,
    content: content
  });
}

function BrowsboxContentList(props) {
  var content = props.content;

  if (content.length < 2) {
    return renderItem(content[0]);
  }

  return React.createElement(
    'div',
    null,
    content.map(renderItem)
  );
}

BrowsboxContentList.propTypes = {
  content: PropTypes.arrayOf(contentPropType).isRequired
};

function render(content) {
  var renderTarget = 'html';
  return ReactDOMServer.renderToStaticMarkup(React.createElement(BrowsboxContentList, {
    content: content.sections,
    renderTarget: renderTarget
  }));
}

/* eslint-disable import/prefer-default-export */

export { render, ContentSectionBase, ContentComponentButton as Button, ContentComponentDynamic as Dynamic, ContentComponentGalleryImage as GalleryImage, ContentGoogleMaps as GoogleMaps, ContentComponentHr as Hr, ContentComponentHtml as Html, ContentComponentImage as Image, ContentComponentImageContainer as ImageContainer, ContentComponentSliderImage as SliderImage, ContentComponentTitle$1 as Subtitle, ContentComponentText as Text, ContentComponentTitle as Title, ContentComponentVideo as Video, LinkedImage, CONTENT_COMPONENT_TYPE, CONTENT_SECTION_TYPE, DEFAULT_COLUMN_COUNT, IMAGE_PLACEHOLDER_URL, LIGHTBOX_CLASSNAME, moduleOptionsProps, moduleDefaultOptionsProps, getYoutubeEmbedUrl, isVideoUrl, getLargeImageUrl, getWebMediaUrl, LINK_TYPE_NONE, LINK_TYPE_INTERNAL, LINK_TYPE_EXTERNAL, LINK_TYPE_EMAIL, completeUrl, getLinkType, containerClass, BUTTON_MODE, MIN_RATIO, MAX_RATIO, DEFAULT_RATIO, IMAGE_TYPE_REGULAR, IMAGE_TYPE_ROUNDED, MIN_ROUNDED_HEIGHT, contentColumnPropType, contentColumnDefaultProps, contentPropType, contentDefaultProps, contentComponentPropType, contentLayoutProps };



//////////////////
// WEBPACK FOOTER
// ../browsbox-static/lib/main.es.js
// module id = 12
// module chunks = 0